/*jslint nomen:true, indent:4*/
/*global define*/

define(function () {
    return function(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
});
